let resultModel = {
  code: 0,
  message: "Object message",
  recordCount: 0,
  header: {
    portalUsername: 0,
    userName: "",
    employeeId: "",
    profileImage: ""
  },
  data: {
    id: 0,
    pageLabel: "",
    pageLink: "",
    parent: 0,
    icon: ""
  },
  extraInfo: ""
};
export { resultModel };
